<!--
 * @Description: 用户信息展示组件，由index.js 配置引入
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-21 13:25:43
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<template>
    <div>
        <comp-title-dc back-url-name="acctManager">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/acctManager' }">账户信息</el-breadcrumb-item>
                <el-breadcrumb-item>修改基本信息</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div :class="'bizcomp-modify-info bizcomp ' + className">
            <user-info />
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import userInfo from "@/components/acctInfo/userInfoDc";

export default {
    name: "ModifyInfo",
    components: {
        userInfo
    },
    mixins: [mixin],
    data() {
        return {};
    },
    mounted() {},
    methods: {}
};
</script>
